app.service('apiService', function ($http) {

  const map_marker_color = '289ad1'
  const map_marker_maki_icon = 'circle'
  const subj_map_size = '140x100'
  const mapbox_access_token = 'pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q'

  let _analysis = null
  let _subjectMap = null

  this.getAnalysis = function (obj) {
    return $http.post('/apis/getAnalysis', obj)
      .then(function (response) {
        // console.log('response :>> ', response);
        return response
      })
  }
  this.countyList = function (obj) {
    return $http.post('/apis/countyList', obj)
      .then(function (response) {
        console.log('response :>> ', response);
        return response
      })
  }

  // Mapbox functions
  this.getMapboxAccessToken = function () {
    return mapbox_access_token
  }
  this.setSubjectMap = function (obj) {

    _subjectMap = `https://api.mapbox.com/styles/v1/mapbox/light-v11/static/pin-l-${map_marker_maki_icon}+${map_marker_color}(${obj.lng},${obj.lat})/${obj.lng},${obj.lat},14.5,0,60/${subj_map_size}?attribution=false&logo=false&access_token=${mapbox_access_token}`
    return _subjectMap
  }
  this.getSubjectMap = function () {
    _subjectMap
  }

  // ------------------------------------------------

  //  functions to load/store _analysis data from the API
  this.storeAnalysis = function (data) {
    _analysis = data
  }
  this.loadAnalysis = function () {
    return new Promise(function (resolve, reject) {
      resolve(_analysis)
    })
  }
  this.clearAnalysis = function () {
    _analysis = null
  }
  this.analysisLoaded = function () {
    return (_analysis != null)
  }

})
